import { exceptions } from '../_content/_exceptions';

export const titleCase = str => str.toLowerCase().split(' ').map(word => {
	if (exceptions[word] === undefined) return word.charAt(0).toUpperCase() + word.slice(1);
	return word;
}).join(' ');
